export default "__VITE_ASSET__BuTpo9yC__"